import React from "react"
import { BarraSoluciones } from "../../../BarraSoluciones"
import { SolucionesHeaders } from "../../SolucionesHeaders"
import { ComponentesPolycom } from "../ComponentesPolycom"
import { EquiposInfraestructuraImg } from "../../../CarouselImages/Videoconferencia/EquiposInfraestructuraImg"
import { TelepresenciaImg } from "../../../CarouselImages/Videoconferencia/TelepresenciaImg"
import { EquiposSalaG700Img } from "../../../CarouselImages/Videoconferencia/EquiposSalaG700Img"
import { EquiposSalaG500Img } from "../../../CarouselImages/Videoconferencia/EquiposSalaG500Img"
import { EquiposSalaG300Img } from "../../../CarouselImages/Videoconferencia/EquiposSalaG300Img"
import { SolucionesPersonalesDesktopImg } from "../../../CarouselImages/Videoconferencia/SolucionesPersonalesDesktopImg"
import { SolucionesPersonalesMobileImg } from "../../../CarouselImages/Videoconferencia/SolucionesPersonalesMobileImg"
import { SolucionesVozImg } from "../../../CarouselImages/Videoconferencia/SolucionesVozImg"
import { SolucionesLyncImg } from "../../../CarouselImages/Videoconferencia/SolucionesLyncImg"
import "./info.scss"

export const InfoSection = ({ classTitle, mainTitle }) => {
  const equipoInfra = {
    title: ["PLATAFORMA", "REAL PRESENCE"],
    description: [
      "La plataforma RealPresence es la infraestructura inteligente que resuelve los problemas al ofrecer un servicio de videoconferencia segura, fácil de usar y de alta definición.",
    ],
    list: [
      "Colaboración de Video Universal.",
      "Aplicaciones de Gestión.",
      "Seguridad y Firewall Transversal.",
      "Gestión de contenido de Video.",
      "CloudAXIS.",
    ],
  }

  const telepresencia = {
    title: ["OPEN TELEPRESENCE", "EXPERIENCE"],
    description: [
      "Colaboración eficaz de vídeo, audio y contenido en un entorno moderno e inmersivo.",
      "Polycom Open Telepresence Experience (OTX) lleva los beneficios de productividad de la telepresencia inmersiva a casi cualquier tipo de reunión. Los grupos de trabajo de colaboración, equipos de desarrollo globales y reuniones diarias se perfeccionan gracias a la claridad, vídeo enriquecido y detalles de contenido aportados. Su excepcional diseño multiobjetivo transmite imágenes en tamaño completo de increíble nitidez en un sistema moderno y único.",
      "Polycom OTX es el entorno ideal para la colaboración visual, incluso para llamar a otras salas inmersivas o a cualquier sistema de vídeo basado en estándares. Ofrece, además, interoperabilidad nativa con las plataformas de comunicaciones unificadas como Microsoft® Lync®.",
    ],
  }

  const group700 = {
    title: ["REAL PRESENCE", "GROUP 700"],
    description: [
      "Máximo rendimiento y flexibilidad en la colaboración de video para grandes grupos - cuando lo que se necesita es lo mejor. Opción de licencia multipunto para un máximo de 8 sitios. El Polycom® RealPresence® Group 700 es la solución ideal para reuniones que requieren el máximo rendimiento y flexibilidad, desde salas de juntas hasta grandes salas de conferencia.",
    ],
  }

  const group500 = {
    title: ["REAL PRESENCE", "GROUP 500"],
    description: [
      "Impactante colaboración de video para conferencias de grupo con elegante diseño y facilidad de uso. El Polycom RealPresence® Group 500 es ideal para salas de conferencias y otros entornos de colaboración, desde pequeñas salas de reuniones hasta habitaciones más grandes con pantallas dobles. Opción de licencia multipunto para un máximo de 6 sitios (SDCP), o 4 sitios (HDCP).",
    ],
  }

  const group300 = {
    title: ["REAL PRESENCE", "GROUP 300"],
    description: [
      "Extraordinario rendimiento, facilidad de uso e interoperabilidad a un precio razonable. El Polycom® RealPresence® Group 300 está optimizado para grupos más pequeños, es ideal para salas de reuniones pequeñas, salas poco espaciosas y oficinas. Equipo únicamente punto a punto.",
    ],
  }

  const desktop = {
    title: ["REAL PRESENCE", "DESKTOP"],
    description: [
      "Otorgando excelente colaboración de vídeo a las personas",
      "RealPresence Desktop para Windows libera a los profesionales de los límites tradicionales de la sala de conferencias, lo que les permite disfrutar de la colaboración de vídeo desde sus ordenadores personales. Ahora puede reunirse frente a frente con cualquier persona, desde cualquier lugar, mejorando el trabajo en equipo, toma de decisiones colaborativas y la productividad con los colegas, clientes y socios comerciales.",
      "La solución de software de vídeo HD de clase empresarial de Polycom brinda la gestión de aplicaciones, la interoperabilidad, la escalabilidad, la flexibilidad, la seguridad, el sistema multipunto y la calidad realista que los usuarios y responsables de TI exigen.",
    ],
  }

  const mobile = {
    title: ["REAL PRESENCE", "MOBILE"],
    description: [
      "Polycom RealPresence Mobile es una aplicación de software premiada que permite a los clientes ampliar el uso de colaboración de vídeo HD de manera segura más allá de la sala de conferencias mediante la conexión de tablets y smartphones (iOS and Android) de manera sencilla con otros sistemas de vídeo basados en estándares. La solución de software incorporada en la plataforma Polycom RealPresence proporciona el aprovisionamiento, la redundancia, la flexibilidad y la fiabilidad necesarios para las implementaciones en los móviles a gran escala.",
      "Ahora puede comunicarse y colaborar cara a cara desde cualquier parte con cualquier persona (colegas, socios, clientes, alumnos, pacientes), todo ello con audio y vídeo HD, y funciones de uso compartido de contenidos.",
    ],
  }

  const voz = {
    title: ["POLYCOM", "SOUNDSTATION"],
    description: [
      "Polycom ofrece equipos con un rendimiento excepcional y funciones de gran solidez para las organizaciones que trabajan en plataformas VoIP basadas en SIP, así como analógicos. Modelos ideales para salas de juntas, salas de conferencias, auditorios y oficinas ejecutivas. ",
      "Para salas pequeñas, medianas o grandes. Modelos inalámbricos o con cable.",
    ],
  }

  const lync = {
    title: ["PLATAFORMAS DE", "COMUNICACIÓN"],
    description: [
      "Las personas se sienten cómodas cuando usan soluciones Microsoft para comunicarse en el trabajo y en el hogar. Las soluciones Polycom permiten a cualquier persona que opera en un entorno de Microsoft realizar llamadas de voz y vídeo con funciones empresariales y compartir contenido en alta definición con solo tocar un botón.",
      "Muchas otras plataformas de comunicación se unen entre sí después de su creación. La interoperabilidad forma parte del ADN de Polycom. Polycom construye sus soluciones desde cero y las optimiza para Microsoft Lync. Con Polycom, su negocio se conectará con otros con la ayuda de una completa solución que abarca voz, vídeo, mensajería instantánea, compartición de contenidos y presencia.",
    ],
  }

  return (
    <>
      <div className={`info-${classTitle}-container`}>
        <SolucionesHeaders
          titleSolucion={mainTitle.toUpperCase()}
          cNameSolucion={classTitle}
        />
        <div
          className={`info-${classTitle}-description-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <p>
            <span>SKOL SOLUTIONS </span>
            es canal de ventas para la línea de terminales de videoconferencia,
            productos de infraestructura y servicios de <span>POLYCOM </span> en
            Uruguay.
          </p>
          <p>
            <span>POLYCOM </span>
            ofrece la experiencia de comunicación y reuniones remotas más
            realista, desde cualquier lugar del mundo y de forma instantánea. En
            la actualidad, es el único proveedor de soluciones de Colaboración
            Unificada integradas que permiten a las organizaciones superar los
            desafíos de productividad y contención de costos.
          </p>
          <p>
            Como líder del mercado en soluciones de Colaboración Unificada,
            <span>POLYCOM </span> aprovecha la creciente demanda de soluciones
            de colaboración de las empresas. Tenemos más de 600 patentes
            aprobadas o en trámite y más de 15 millones de líneas de código
            activo en nuestra cartera de productos.
          </p>
        </div>

        <div className={`polycom-container`}>
          <h3
            className={`${classTitle}-title-container`}
            data-sal="slide-up"
            data-sal-delay="200"
            data-sal-easing="ease"
          >
            EQUIPOS DE <span>INFRAESTRUCTURA</span>
          </h3>

          <ComponentesPolycom
            classTitle={classTitle}
            cover={true}
            polycomInfo={equipoInfra}
            images={EquiposInfraestructuraImg}
            s1920="512px"
            s1366="530px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />

          <hr className="polycom-separator" />

          <h3 className={`${classTitle}-title-container`}>
            TELEPRESENCIA <span>INMERSIVA</span>
          </h3>
          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={telepresencia}
            images={TelepresenciaImg}
            s1920="512px"
            s1366="530px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />

          <hr className="polycom-separator" />

          <h3 className={`${classTitle}-title-container`}>
            EQUIPOS DE <span>SALA</span>
          </h3>
          <p className="equipo-sala">
            La serie Polycom RealPresence Group (700, 500 y 300) aporta un nuevo
            nivel de eficacia y productividad a la colaboración por grupos en
            las salas de su empresa, mediante la combinación de una excelente
            experiencia de vídeo con una nueva interfaz sencilla e innovadora
            que es fácil de usar desde el primer día.
          </p>
          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={group700}
            images={EquiposSalaG700Img}
            s1920="413px"
            s1366="400px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />
          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={group500}
            images={EquiposSalaG500Img}
            s1920="413px"
            s1366="400px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />
          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={group300}
            images={EquiposSalaG300Img}
            s1920="413px"
            s1366="400px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
            cover={true}
          />

          <hr className="polycom-separator" />

          <h3 className={`${classTitle}-title-container`}>
            SOLUCIONES PERSONALES - <span>ESCRITORIO O MOVIL</span>
          </h3>
          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={desktop}
            images={SolucionesPersonalesDesktopImg}
            s1920="512px"
            s1366="530px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />

          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={mobile}
            images={SolucionesPersonalesMobileImg}
            s1920="512px"
            s1366="530px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />

          <hr className="polycom-separator" />

          <h3 className={`${classTitle}-title-container`}>
            SOLUCIONES DE <span>VOZ</span>
          </h3>
          <p className="soluciones-voz1">
            Comunicaciones de voz claras para cualquier entorno de sala de
            reuniones.
          </p>
          <p className="soluciones-voz2">
            Los teléfonos de conferencia Polycom proporcionan una calidad de voz
            superior, recepción de micrófono expansiva y procesamiento de audio
            avanzado, lo que aporta naturalidad a las conferencias y crea la
            ilusión de estar en la misma sala.
          </p>

          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={voz}
            images={SolucionesVozImg}
            s1920="512px"
            s1366="440px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />

          <hr className="polycom-separator" />

          <h3 className={`${classTitle}-title-container`}>
            SOLUCIONES PARA <span>LYNC</span>
          </h3>
          <ComponentesPolycom
            classTitle={classTitle}
            polycomInfo={lync}
            images={SolucionesLyncImg}
            s1920="512px"
            s1366="490px"
            s1024="327px"
            s768="235px"
            s640="228px"
            s360="192px"
          />
        </div>

        <BarraSoluciones />
      </div>
    </>
  )
}
